export default {
  contact: {
    hero: {
      eyebrow: 'Kontakt',
      title: 'Sprechen Sie uns an',
      lead: 'Ob erste Informationen, konkrete Planung oder eine Besichtigung vor Ort – wir freuen uns auf Ihre Nachricht.',
    },
    info: {
      partner: 'Ihr Partner für Sicherheitstechnik',
      owner: 'Inhaber',
      address: 'Adresse',
      phone: 'Telefon',
      email: 'E-Mail',
      hours: 'Geschäftszeiten',
      area: 'Einsatzgebiet',
      viewAreas: 'Alle Einsatzgebiete ansehen',
    },
    form: {
      title: 'Projektanfrage',
      lead: 'Füllen Sie das Formular aus. Wir melden uns zeitnah bei Ihnen.',
      customerType: 'Privat oder Gewerbe *',
      select: 'Bitte wählen',
      privat: 'Privat',
      gewerbe: 'Gewerbe',
      name: 'Name *',
      company: 'Unternehmen',
      phone: 'Telefon',
      email: 'E-Mail *',
      projectLocation: 'Projektort',
      objectType: 'Objektart',
      objEfh: 'Einfamilienhaus',
      objMfh: 'Mehrfamilienhaus',
      objLaden: 'Einzelhandel / Laden',
      objBuero: 'Büro / Praxis',
      objGastronomie: 'Gastronomie',
      objLager: 'Lager / Logistik',
      objWerkstatt: 'Werkstatt / Gewerbe',
      objSonstige: 'Sonstige',
      service: 'Gewünschte Leistung',
      svcBeratung: 'Erstberatung',
      svcPlanung: 'Planung & Angebot',
      svcInstallation: 'Installation & Einrichtung',
      svcErweiterung: 'Erweiterung vorhandener Anlage',
      svcWartung: 'Wartung / Betreuung',
      svcCare: 'SSG Care-Anfrage',
      systemStatus: 'Anlagenstatus',
      stNeu: 'Neue Anlage',
      stBestehend: 'Bestehende Anlage erweitern',
      stAustausch: 'Komplettaustausch',
      stUnsicher: 'Noch unsicher',
      message: 'Nachricht',
      messagePlaceholder: 'Beschreiben Sie kurz Ihr Projekt oder Ihre Fragen...',
      maxChars: 'Maximal 500 Zeichen',
      fileUpload: 'Datei-Upload',
      fileHint: 'Fotos, Grundrisse oder andere Dokumente (optional)',
      fileNote: 'Hinweis: Datei-Uploads werden als "Uncollectable" behandelt.',
      callback: 'Bevorzugter Rückrufzeitraum',
      callbackNone: 'Kein Rückruf gewünscht',
      vormittag: 'Vormittag',
      nachmittag: 'Nachmittag',
      abend: 'Abend',
      consent: 'Ich habe die Datenschutzerklärung gelesen und stimme der Verarbeitung meiner Daten zur Bearbeitung dieser Anfrage zu. *',
      success: 'Vielen Dank für Ihre Anfrage. Wir melden uns zeitnah bei Ihnen.',
      submit: 'Anfrage senden',
      submitting: 'Wird gesendet...',
    },
  },
};